import React from "react";
import { Popover } from "antd";
import { useSelector } from "react-redux";
import { GLOSSARY } from "../../../glossary";
import type { RootState } from "../../../redux/appState";

interface InfoAffordanceProps {
  glossaryKey: string;
}

const InfoAffordance = ({ glossaryKey }: InfoAffordanceProps) => {
  const glossaryEntries = useSelector((state: RootState) => state.coilConfigurator.glossary.entries);
  const glossaryLoaded = useSelector((state: RootState) => state.coilConfigurator.glossary.loaded);
  const entry =
    (glossaryLoaded ? glossaryEntries[glossaryKey] : undefined) ?? GLOSSARY[glossaryKey];

  if (entry === undefined) {
    return null;
  }

  return (
    <Popover
      content={<p style={{ margin: 0, maxWidth: 280 }}>{entry.definition}</p>}
      title={entry.title}
      trigger={["hover", "focus"]}
      mouseEnterDelay={0.15}
      mouseLeaveDelay={0.1}
    >
      <button
        type="button"
        className="info-affordance"
        aria-label={`Definition: ${entry.title}`}
      >
        ⓘ
      </button>
    </Popover>
  );
};

export default InfoAffordance;
